import { DspStatus } from 'src/drugScreening/types';

export const ScreeningStatusLabelMap = {
  [DspStatus.Complete]: 'complete',
  [DspStatus.OnTrack]: 'on track',
  [DspStatus.AtRisk]: 'at risk',
  [DspStatus.RegulatoryPause]: 'reg. pause',
  [DspStatus.BuprenorphineNegativeProtocol]: 'bupe neg.',
};

export const ScreeningStatusColorMap = {
  [DspStatus.Complete]: 'neutral',
  [DspStatus.OnTrack]: 'success',
  [DspStatus.AtRisk]: 'warning',
  [DspStatus.BuprenorphineNegativeProtocol]: 'warning',
  [DspStatus.RegulatoryPause]: 'error',
};
